import withAntIconWrapper from '../hooks/useAntIconWrapper';
import { ReactComponent as ConferenceIconImport } from './camcorder_line.svg';
import { ReactComponent as WebcastIconImport } from './presentation_2_line.svg';
import { ReactComponent as TelehealthIconImport } from './telehalth.svg';

export const ConferenceIcon = withAntIconWrapper(ConferenceIconImport);
export const WebcastIcon = withAntIconWrapper(WebcastIconImport);
export const TelehealthIcon = withAntIconWrapper(TelehealthIconImport);
